const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const toDollarFormat = (number: number | bigint) => formatter.format(number);

export default toDollarFormat;
